import {
  PRACTICE_FOUNDERS,
  PRACTICE_TYPES,
  type AccountType,
  type PracticeStatus,
  type PracticeType,
  type Role,
} from '@curentia/shared';

export const PRACTICE_TYPE_LABELS: Record<PracticeType, string> = {
  solo: 'Solo practice',
  clinic: 'Clinic',
  small_hospital: 'Small hospital',
  pharmacy: 'Pharmacy',
};

export const PRACTICE_TYPE_BLURBS: Record<PracticeType, string> = {
  solo: 'Just you. The records stay on this device.',
  clinic: 'Doctors and staff together. The records stay on a hub PC in the clinic.',
  small_hospital: 'Like a clinic, for a hospital with wards. The records stay on a hub PC.',
  pharmacy: 'Receive prescriptions and keep the dispensing register.',
};

export const ROLE_LABELS: Record<Role, string> = {
  patient: 'Patient',
  doctor: 'Doctor',
  practice_admin: 'Practice admin',
  front_desk: 'Front desk',
  pharmacist: 'Pharmacist',
  platform_admin: 'Platform admin',
};

export const ROLE_BLURBS: Partial<Record<Role, string>> = {
  doctor: 'Sees patients’ records and writes prescriptions',
  practice_admin: 'Manages members and invitations',
  front_desk: 'Registers patients and sees their contact details only',
  pharmacist: 'Sees prescriptions and dispensing',
};

export const ACCOUNT_TYPE_LABELS: Record<AccountType, string> = {
  patient: 'Patient',
  doctor: 'Doctor',
  pharmacist: 'Pharmacist',
  staff: 'Clinic staff',
  platform_admin: 'Platform admin',
  hub: 'Clinic hub',
};

export const STATUS_LABELS: Record<PracticeStatus, string> = {
  pending: 'Waiting for verification',
  active: 'Active',
  rejected: 'Not approved',
  suspended: 'Suspended',
};

export function roleList(roles: readonly Role[]): string {
  return roles.map((role) => ROLE_LABELS[role]).join(', ');
}

/** Kinds of practice this account may set up. */
export function foundableTypes(type: AccountType): PracticeType[] {
  return PRACTICE_TYPES.filter((practiceType) => PRACTICE_FOUNDERS[practiceType].includes(type));
}

/** Accounts that work inside practices, as opposed to patients and the platform admin. */
export function worksInPractices(type: AccountType | undefined): boolean {
  return type === 'doctor' || type === 'pharmacist' || type === 'staff';
}
